module.exports = __webpack_public_path__ + "img/img20.5e72aa1e.png";